module.exports = __webpack_public_path__ + "static/3-34fbffbe3631496bba04361432042bb8.jpg";